module.exports = __webpack_public_path__ + "img/job-white-collar.109be0cf.svg";